<template lang="pug">
liondesk-dialog-v2(
    :value="value"
    dialogTitle="Important update about your texting"
    okButtonText="Learn More"
    cancelButtonText="Go Back"
    @click:ok="goToTextConsole"
    @click:cancel="cancel"
)
  div(slot="body")
    v-divider.primary-color.pb-2
    v-layout(wrap).pb-3.justify-center
      div.headline.font-weight-bold Your texting is disabled in LionDesk
      div.icon-stack
        div.material-icons.icon.stacked-icon stay_current_portrait
        div.material-icons.icon.stacked-icon.stacked.error-color block
    div Due to a high number of your contacts opting out and your messages being filtered by carriers, all your texting capabilities have now been disabled. You will not be charged for your monthly texting fee starting next month.
</template>

<script>
import LiondeskDialogV2 from '@/Core/components/LiondeskDialogV2';

export default {
  components: {
    LiondeskDialogV2,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    cancel() {
      this.$emit('close');
    },
    goToTextConsole() {
      this.$router.push({ name: 'communications.text.text-management', hash: '#health'});
    },
  },
}
</script>

<style lang="scss" scoped>
.icon-stack {
  margin-left: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.stacked-icon {
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: center;
}

.stacked {
  background-color: transparent !important;
  font-size: 35px !important;
}

.error-color {
  color: var(--v-error-base)
}

.primary-color {
  color: var(--v-primary-base)
}
</style>
